var map = {
	"./10.jpg": 153,
	"./2.jpg": 154,
	"./3.jpg": 155,
	"./5.jpg": 156,
	"./6.jpg": 157,
	"./7.jpg": 158,
	"./8.jpg": 159,
	"./9.jpg": 160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 152;